<div class="content-body inner-table-html p-0" style="min-height: 100%;">
    <div *ngIf="fileDetails" [innerHtml]="transformYourHtml()"></div>
  </div>